<ng-container *transloco="let formlyFileUploaderTranslation; read: 'formly-file-uploader'">
    <ng-container *transloco="let fieldTranslation; read: 'field-types'">
        <div *ngIf="loading$ | async" class="inset-x-0 top-0">
            <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </div>
        <div class="flex flex-col">
            <div
                class="flex items-start space-x-4"
                [ngClass]="!(datasource.length >= maxNumberOfFiles) ? 'mt-12 mb-8' : 'mt-4'"
            >
                <ngx-file-drop
                    class=""
                    (onFileDrop)="dropped($event)"
                    [multiple]="true"
                    [accept]="fileTypes?.join(',')"
                    [directory]="false"
                    dropZoneClassName=""
                    [disabled]="isDisabled()"
                    *ngIf="!(datasource.length >= maxNumberOfFiles)"
                >
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                        <div class="bg-card rounded border border-dashed flex p-4 space-x-8">
                            <div class="flex flex-col space-y-2 items-center place-content-center">
                                <mat-icon class="w-20 h-20 text-accent" svgIcon="mat_outline:upload_file"></mat-icon>
                                <span *ngIf="maxNumberOfFiles"
                                    >{{ fieldTranslation("Drag up to", { maxNumberOfFiles: maxNumberOfFiles }) }}
                                </span>

                                <span *ngIf="!maxNumberOfFiles">{{ fieldTranslation("Drag files") }} </span>
                                <button
                                    mat-button
                                    color="primary"
                                    (click)="openFileSelector()"
                                    [disabled]="isDisabled()"
                                >
                                    <span>{{ fieldTranslation("Select files") }}</span>
                                </button>
                            </div>
                        </div>
                    </ng-template>
                </ngx-file-drop>

                <div class="flex flex-wrap self-center" *ngIf="datasource && datasource.length > 0">
                    <div
                        class="flex items-center justify-between w-48 p-2 border rounded mr-4 mb-4 bg-card"
                        *ngFor="let item of datasource"
                    >
                        <span class="truncate" *ngFor="let objectProperties of item | keyvalue">
                            {{ objectProperties.key }}
                        </span>
                        <button mat-icon-button color="warn" (click)="removeItem(item)">
                            <mat-icon svgIcon="mat_outline:close"></mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col space-y-4" [ngClass]="!(datasource.length >= maxNumberOfFiles) ? 'my-6' : 'mb-6'">
                <mat-hint>{{ formlyFileUploaderTranslation("50 MB limitation") }}</mat-hint>
                <mat-error *ngIf="fileTypes && fileTypes?.length > 0 && filesWithTypeError.length > 0" color="warn">
                    {{ formlyFileUploaderTranslation("The files") }}
                    <span *ngFor="let file of filesWithTypeError">{{ file.fileEntry.name }}</span>
                    <span>{{
                        formlyFileUploaderTranslation("Mismatching file types", { fileTypes: fileTypes.join(", ") })
                    }}</span>
                </mat-error>
            </div>
        </div>
    </ng-container>
</ng-container>
